import { render, staticRenderFns } from "./UsersStatisticsTable.vue?vue&type=template&id=50b27020&scoped=true"
import script from "./UsersStatisticsTable.vue?vue&type=script&lang=js"
export * from "./UsersStatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./UsersStatisticsTable.vue?vue&type=style&index=0&id=50b27020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b27020",
  null
  
)

export default component.exports